import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AttendanceLandingPageComponent } from './attendance-landing-page/attendance-landing-page.component';
import { AttendanceLinkComponent } from './attendance-link/attendance-link.component';

const routes: Routes = [
  {
    path:'',component:AttendanceLinkComponent,
    children:[
      {
        path:'Attendance',component:AttendanceLandingPageComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendanceRoutingModule { }
